import {ActionList, ActionMenu, RelativeTime, IconButton} from '@primer/react'
import {SinceSource} from '../../../routes/route-payload-types'
import {useEffectiveSelection} from '../data/use-effective-selection'
import {FilterIcon} from '@primer/octicons-react'
import {usePullRequestAnalytics} from '../../../hooks/use-pull-request-analytics'

const sinceSourceDescriptionMap: Record<SinceSource, string> = {
  [SinceSource.Created]: 'Since this pull request was created',
  [SinceSource.LastReview]: 'Since your last review',
  [SinceSource.LastInteracted]: 'Since you last interacted',
  [SinceSource.ReadyForReview]: 'Since marked ready for review',
}

export function ActivitySelector() {
  const {sinceSelectors, effectiveSelection, handleSelect} = useEffectiveSelection()
  const {sendPullRequestAnalyticsEvent} = usePullRequestAnalytics()

  if (!effectiveSelection || sinceSelectors.length === 0) return null

  return (
    <span className="d-flex flex-row gap-2 align-items-center">
      <ActionMenu>
        <ActionMenu.Anchor>
          <IconButton
            icon={FilterIcon}
            size="small"
            variant="invisible"
            aria-label={`Filter activity: ${sinceSourceDescriptionMap[effectiveSelection.source]}`}
          />
        </ActionMenu.Anchor>
        <ActionMenu.Overlay align="end">
          <ActionList selectionVariant="single">
            {sinceSelectors.map(selector => (
              <ActionList.Item
                key={selector.source}
                selected={selector.source === effectiveSelection?.source}
                onSelect={() => {
                  sendPullRequestAnalyticsEvent('overview.activity_filter_change', 'OVERVIEW_ACTIVITY_SELECTOR', {
                    source: selector.source,
                  })
                  handleSelect(selector)
                }}
              >
                {sinceSourceDescriptionMap[selector.source]}
                <ActionList.Description>
                  <RelativeTime date={new Date(selector.timestamp)} />
                </ActionList.Description>
              </ActionList.Item>
            ))}
          </ActionList>
        </ActionMenu.Overlay>
      </ActionMenu>
    </span>
  )
}
